// import Menu from '../views/Menu.vue'
import AccountManagement from '../views/AccountManagement.vue'
import MemberManagement from '../views/MemberManagement.vue'
import JobManagement from '../views/JobManagement.vue'
import IntershipNewsManagement from '../views/IntershipNewsManagement.vue'
import MaterialManagement from '../views/MaterialManagement.vue'
import RecruitmentTypeManagement from '../views/RecruitmentTypeManagement'
import IndustryTypeManagement from '../views/IndustryTypeManagement'
import CompanyTypeManagement from '../views/CompanyTypeManagement'
import MaterialCategoryManagement from '../views/MaterialCategoryManagement.vue'
import MaterialTagManagement from '../views/MaterialTagManagement.vue'
import InterviewExpManagement from '../views/InterviewExpManagement.vue'
import NeiTuiManagement from '../views/NeiTuiManagement.vue'
import CourseCategoryManagement from '../views/CourseCategoryManagement.vue'
import CourseManagement from '../views/CourseManagement.vue'
import UserSourceChannel from '../views/UserSourceChannel.vue'
import MemberCoursePermissionManagement from '../views/MemberCoursePermissionManagement.vue'
import OfferXianSheng from '../views/OfferXianSheng.vue'
import JikeMiaoMiaoXiang from '../views/JikeMiaoMiaoXiang.vue'

const PlatformChildrenRouterList = [
    {
        index: 0,
        icon: 'mdi-view-dashboard',
        title: '總覽',
        path: '/menu',
        component: OfferXianSheng
    },
    {
        index: 1,
        icon: 'mdi-account-group',
        title: '用戶管理',
        path: '/user-management',
        children: [
            {
                title: '账号管理',
                path: '/user-management/account',
                component: AccountManagement
            },
            {
                title: '学员管理',
                path: '/user-management/member',
                component: MemberManagement
            }
        ]
    },
    {
        index: 2,
        icon: 'mdi-book-open-variant',
        title: '课程相关',
        path: 'course-related',
        children: [
            {
                title: '课程目录管理',
                path: '/course-related/course-category',
                component: CourseCategoryManagement
            },
            {
                title: '课程管理',
                path: '/course-related/course',
                component: CourseManagement
            },
            {
                title: '学员权限管理',
                path: '/course-related/permission',
                component: MemberCoursePermissionManagement
            }
        ]
    },
    {
        index: 3,
        icon: 'mdi-briefcase',
        title: '招聘相关',
        path: 'recruitment',
        children: [
            {
                title: '岗位管理',
                path: '/recruitment/job',
                component: JobManagement
            },
            {
                title: '招聘信息管理',
                path: '/recruitment/news',
                component: IntershipNewsManagement
            },
            {
                title: '招聘类型管理',
                path: '/recruitment/recruitment-type',
                component: RecruitmentTypeManagement
            },
            {
                title: '行业类型管理',
                path: '/recruitment/industry-type',
                component: IndustryTypeManagement
            },
            {
                title: '公司类型管理',
                path: '/recruitment/company-type',
                component: CompanyTypeManagement
            },
            {
                title: '面经管理',
                path: '/recruitment/interview',
                component: InterviewExpManagement
            },
            {
                title: '内推资讯管理',
                path: '/recruitment/nei_tui',
                component: NeiTuiManagement
            }
        ]
    },
    {
        index: 4,
        icon: 'mdi-folder',
        title: '资料相关',
        path: 'material',
        children: [
            {
                title: '学习资料管理',
                path: '/material/files',
                component: MaterialManagement
            },
            {
                title: '资料目录管理',
                path: '/material/categories',
                component: MaterialCategoryManagement
            },
            {
                title: '资料标签管理',
                path: '/material/tags',
                component: MaterialTagManagement
            },
        ],
    },
    {
        index: 5,
        icon: 'mdi-share-variant',
        title: '渠道管理',
        path: '/userSourceChannel',
        component: UserSourceChannel
    },
    {
        index: 6,
        icon: 'mdi-gift',
        title: '即刻妙妙箱',
        path: '/jikeMiaoMiaoXiang',
        component: JikeMiaoMiaoXiang
    }
]

          
          
export {
    PlatformChildrenRouterList
}